/**
 * #######################################################
 *
 * Filtre de fraîcheur pour les pages MESSAGE IN / MESSAGE OUT
 *
 * Trois boutons, un seul actif à la fois. Un clic sur le bouton actif
 * le désactive et retire le filtre.
 *
 * #######################################################
 */
import PropTypes from "prop-types";
import { Icon, Tooltip } from "@mui/material";
import MDBox from "components/Basics/MDBox";
import MDButton from "components/Basics/MDButton";
import i18n from "i18n";
import { FRESHNESS_LEVELS } from "../messageFreshness";

/**
 * @param {String|null} selected code du niveau actif, null si aucun
 * @param {Function} onChange appelé avec le nouveau code actif (null pour effacer)
 */
function MessageFreshnessFilter({ selected, onChange }) {
	/**
	 * Un clic sur le niveau déjà actif efface le filtre
	 */
	const handleClick = code => {
		onChange(selected === code ? null : code);
	};

	return (
		<MDBox display="flex" alignItems="center" mr={1}>
			{FRESHNESS_LEVELS.map(level => {
				const isSelected = selected === level.code;

				return (
					<MDBox key={level.code} mr={0.5}>
						<Tooltip placement="top" title={i18n.t(`FILTERS.FRESHNESS.${level.code}Tooltip`)}>
							<MDButton
								style={{ height: "100%" }}
								variant={isSelected ? "contained" : "outlined"}
								color={level.color}
								size="small"
								onClick={() => handleClick(level.code)}
							>
								<Icon>{level.icon}</Icon>&nbsp;{i18n.t(`FILTERS.FRESHNESS.${level.code}`)}
							</MDButton>
						</Tooltip>
					</MDBox>
				);
			})}
		</MDBox>
	);
}

MessageFreshnessFilter.defaultProps = {
	selected: null
};

MessageFreshnessFilter.propTypes = {
	selected: PropTypes.string,
	onChange: PropTypes.func.isRequired
};

export default MessageFreshnessFilter;
